import { CategoryColorsEnum } from '../enums/category-colors.enum';

export interface ChipCategory {
  name: string;
  color: string;
  text: string;
}

export class ChipCategories {
  static readonly Default: ChipCategory = { name: '', text: '', color: 'rgba(0, 0, 0, .87)' };

  static readonly Alle: ChipCategory = { name: 'Alle', text: 'A', color: CategoryColorsEnum.Alle };
  static readonly Auswahl: ChipCategory = { name: 'Auswahl', text: 'Aw', color: CategoryColorsEnum.Alle };
  static readonly Patienten: ChipCategory = { name: 'Patienten', text: 'P', color: CategoryColorsEnum.Formulare };
  static readonly Formulare: ChipCategory = { name: 'Formulare', text: 'F', color: CategoryColorsEnum.Formulare };
  static readonly PatientDokumentation: ChipCategory = {
    name: 'Dokumentation',
    text: 'Do',
    color: CategoryColorsEnum.Documentation,
  };
  static readonly Protokoll: ChipCategory = {
    name: 'Protokoll',
    text: 'Pr',
    color: CategoryColorsEnum.Protokoll,
  };
  static readonly Arztbrief: ChipCategory = {
    name: 'Arztbrief',
    text: 'Ab',
    color: CategoryColorsEnum.Arzbrief,
  };
  static readonly PatientCave: ChipCategory = {
    name: 'Cave',
    text: 'Cv',
    color: CategoryColorsEnum.Cave,
  };
  static readonly Testverfahren: ChipCategory = {
    name: 'Testverfahren',
    text: 'T',
    color: CategoryColorsEnum.Testverfahren,
  };
  static readonly Prescriptions: ChipCategory = {
    name: 'Verordnungen',
    text: 'V',
    color: CategoryColorsEnum.Prescriptions,
  };

  static readonly Muster13: ChipCategory = {
    name: 'Heilmittelverordnung',
    text: 'He',
    color: CategoryColorsEnum.Prescriptions,
  };
  static readonly HeilmittelbedarfGenehmigung: ChipCategory = {
    name: 'Heilmittelbedarf Genehmigung',
    text: 'Hg',
    color: CategoryColorsEnum.Prescriptions,
  };

  // Administrative Daten Diagnosen (Suche, Auswahl, Listen)
  static readonly Diagnosen: ChipCategory = { name: 'Diagnosen', text: 'D', color: CategoryColorsEnum.Diagnosen };
  static readonly EigeneDiagnosen: ChipCategory = {
    name: 'Eigene Diagnosen',
    text: 'Dx',
    color: CategoryColorsEnum.Diagnosen,
  };

  // Administrative Daten Leistungen (Suche, Auswahl, Listen)

  static readonly OPSStammdatei: ChipCategory = {
    name: 'OPS-Stammdatei',
    text: 'Lo',
    color: CategoryColorsEnum.Leistungen,
  };
  static readonly EigeneEBMLeistungen: ChipCategory = {
    name: 'eigene EBM Leistungen',
    text: 'Lk',
    color: CategoryColorsEnum.Leistungen,
  };
  static readonly EigeneGOAELeistungen: ChipCategory = {
    name: 'eigene GOÄ Leistungen',
    text: 'Lp',
    color: CategoryColorsEnum.Leistungen,
  };
  static readonly Leistungen: ChipCategory = { name: 'Leistungen', text: 'L', color: CategoryColorsEnum.Leistungen };
  static readonly EBMLeistungen: ChipCategory = {
    name: 'EBM-Leistungen',
    text: 'Lk',
    color: CategoryColorsEnum.Leistungen,
  };
  static readonly Leistungsketten: ChipCategory = {
    name: 'Leistungsketten',
    text: 'Lsk',
    color: CategoryColorsEnum.Leistungsketten,
  };
  static readonly GOAELeistungen: ChipCategory = {
    name: 'GOÄ-Leistungen',
    text: 'Lp',
    color: CategoryColorsEnum.Leistungen,
  };
  static readonly UVLeistungen: ChipCategory = {
    name: 'UV-Leistungen',
    text: 'Lu',
    color: CategoryColorsEnum.Leistungen,
  };

  // Administrative Daten Episoden (Auswahl, Listen)
  static readonly Episodentypen: ChipCategory = {
    name: 'Scheintypen',
    text: 'S',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly Betriebsstaetten: ChipCategory = {
    name: 'Betriebsstätten',
    text: 'Bs',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly Privatliquidationseinheiten: ChipCategory = {
    name: 'Privatliquidationseinheiten',
    text: 'Pl',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly EpisodeGesetzlich: ChipCategory = {
    name: 'Schein gesetzlich',
    text: 'Sg',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly EpisodePrivat: ChipCategory = {
    name: 'Schein privat',
    text: 'Sp',
    color: CategoryColorsEnum.KostenEpisoden,
  };

  // Administrative Daten Kostenträger (Kostenträgersuche, Auswahl)
  static readonly KostentraegerStammdatei: ChipCategory = {
    name: 'Kostenträger aus Stammdatei',
    text: 'K',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly TemporaereKostentraeger: ChipCategory = {
    name: 'Temporäre Kostenträger',
    text: 'Kx',
    color: CategoryColorsEnum.KostenEpisoden,
  };
  static readonly KostentraegerUnfallversicherung: ChipCategory = {
    name: 'Kostenträger der Unfallversicherung',
    text: 'Kb',
    color: CategoryColorsEnum.KostenEpisoden,
  };

  // Administrativ/Klinischer Bereich Arzneimittelverordnung (Suche, Auswahl, Listen)
  static readonly Medikamente: ChipCategory = { name: 'Medikamente', text: 'M', color: CategoryColorsEnum.Medikamente };
  static readonly Wirkstoff: ChipCategory = { name: 'Wirkstoff', text: 'Mw', color: CategoryColorsEnum.Medikamente };
  static readonly Hersteller: ChipCategory = { name: 'Hersteller', text: 'Mh', color: CategoryColorsEnum.Medikamente };
  static readonly Anbieter: ChipCategory = { name: 'Anbieter', text: 'Ma', color: CategoryColorsEnum.Medikamente };
  static readonly Atc: ChipCategory = { name: 'Atc', text: 'Mc', color: CategoryColorsEnum.Medikamente };
  static readonly IwwListen: ChipCategory = { name: 'Iww-Listen', text: 'Iw', color: CategoryColorsEnum.Medikamente };
  static readonly Rezept: ChipCategory = { name: 'Rezept', text: 'R', color: CategoryColorsEnum.Medikamente };
}
